import { create } from "zustand";

interface StepStore {
  step: number;
  maxSteps: number;
  setStep: (newStep: number) => void;
  incrementStep: () => void;
  decrementStep: () => void;
}

export const useStepStore = create<StepStore>((set) => ({
  step: 1,
  maxSteps: 5,

  setStep: (newStep) =>
    set((state) => ({
      step: newStep <= state.maxSteps && newStep >= 1 ? newStep : state.step,
    })),

  incrementStep: () =>
    set((state) => ({
      step: state.step < state.maxSteps ? state.step + 1 : state.step,
    })),

  decrementStep: () =>
    set((state) => ({
      step: state.step > 1 ? state.step - 1 : state.step,
    })),
}));
